export default {
    routerName: '刊物详情',
    journal: {
        title: '标题',
        type: '刊物类型',
        monthJournal: '月刊',
        dayJournal: '日刊',
        image: '刊物图',
        thumb: '缩略图',
        releaseDate: '发行时间',
        body: '目录',
        description: '描述',
        sortOrder: '表示顺',
        status: '状态',
        open: '启用',
        close: '禁用',
        createBy: '创建者',
        createTime: '创建时间',
        updateBy: '更新者',
        updateTime: '更新时间',
    },
};
